import React from "react";

const Contact = () => {
  return (
    <section className="min-h-screen flex justify-center items-center">
      <div className="card w-80 md:w-96 bg-base-100 shadow-xl">
        <div className="card-body">
          <h2 className="text-4xl text-center text-secondary pb-4">
            Contact Form
          </h2>
          <form
            action="https://formsubmit.co/thakursaad613@gmail.com"
            method="POST"
          >
            <input type="hidden" name="_subject" value="Knock! Knock!" />
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              className="w-full input input-bordered my-2"
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              className="w-full input input-bordered my-2"
              required
            />
            <textarea
              type="text"
              name="message"
              placeholder="Your message"
              className="w-full input input-bordered my-2"
              required
            />
            <button type="submit" className="btn btn-primary w-full mt-2">
              Send message
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
